var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Hero',{staticClass:"bg-dark-gray-gradient-angle-bottom"},[_c('h1',{staticClass:"fs-0"},[_vm._v("Is Your Business Machine Friendly?")]),_c('p',[_vm._v("The way your customers find your information is changing")])])
}
var staticRenderFns = []

export { render, staticRenderFns }